<template>
<body style="background-color:#D6D6D6">
    <div class="capacitacion">
        
        
        <!--<h1 class="pl-5 ml-4 pt-5 hidden-xs-only" style="color:#942C75; font-family:Poppins; font-size:1.8vw; font-weight:500">{{title}}</h1>
        <h1 class="pl-5 ml-1 pt-5 hidden-sm-and-up" style="color:#942C75; font-family:Poppins; font-size:4vw; font-weight:500">{{title}}</h1>-->
        <!--<v-layout row wrap>
            <v-flex sm4 md4 lg3 class="pl-4 ml-4 pt-5" >
            <v-card style="background-color:#B22F4A">
              <v-card-title><span class="titlevideos" style="color:white; font-family:Poppins;  font-weight:600">VIDEOS</span></v-card-title>
            </v-card>
            </v-flex>
            <v-flex md1 class="pt-5" >
            <v-card flat style="background-color:#D6D6D6">
              <img src="videos.png"  style="position:absolute;margin-left:-30px; margin-top:-2px" />
            </v-card>
            </v-flex>
            </v-layout>-->
        <ContentVideos>

        </ContentVideos>

    </div>
    </body>
</template>


<script>
import ContentVideos from "@/components/ContentVideos.vue"




export default {
   
    components:{
       ContentVideos,
     },

     data(){
         return{
             
             title:"VIDEOS",
             
         }
     }
    
    
}
</script>

<style >
    @media (min-width: 1200px){
  .titlevideos{
    font-size:1.2vw;
  }
}

@media (min-width: 300px) and (max-width: 750px){
  .titlevideos{
    font-size:4.2vw;
  }
}
</style>

